"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _createIconComponent = _interopRequireDefault(require("./utils/createIconComponent"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var IconCaretDown = (0, _createIconComponent["default"])({
  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
    d: "M57.49 21.6a3.85 3.85 0 0 0-5.44 0l-17 17-17-17a3.85 3.85 0 0 0-5.45 0 3.85 3.85 0 0 0 0 5.45L35 49.54l22.5-22.48a3.85 3.85 0 0 0-.01-5.46z"
  })),
  height: undefined,
  width: undefined
});
IconCaretDown.displayName = 'IconCaretDown';
var _default = IconCaretDown;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@tecuity/sos-icons/react/caret-down.js
// module id = 50
// module chunks = 0